import { IAppState } from 'shared/common/state';

export const isChatExistSelector = (state: IAppState): boolean => {
  return state.consultantCianChat.isConsultantChatExist;
};
